/**
 * Helper: Localize URL
 * -----------------------------------------------------------------------------
 * Adds locale to URL when needed.
 *
 * @param {String} url - URL
 * @returns {String} Localized URL
 *
 */

export default (url = '') => {
  if (typeof url !== 'string' || !window.cnvs) {
    return url
  }

  const root = window.cnvs.routes.root

  // Nothing to do
  if (root === '/' || url.includes(root)) {
    return url
  }

  // Absolute urls
  if (
    url.includes(window.location.hostname) &&
    (url.startsWith('http://') || url.startsWith('https://'))
  ) {
    return url.replace(window.location.hostname, window.location.hostname + root)
  }

  // Relative urls
  if (url.startsWith('/')) {
    return `${root}${url}`
  }

  return url
}
